import React, { useEffect, useState } from "react";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsFillCloudUploadFill } from "react-icons/bs";
import "react-tabs/style/react-tabs.css";

const UserProfile = () => {
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [get_user_profile, setget_user_profile] = useState([]);
  let [disablestatus, setdisablestatus] = useState(false);
  let [showp_image, setpimage] = useState();
  let [profilevalue, setprofilevalue] = useState({
    user_id: _id,
    full_name: "",
    email: "",
    user_image: "",
    pin: "",
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const items = { user_id: _id };

        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          items,
          {
            headers: {
              token: token,
            },
          }
        );

        if (res.data.result) {
          setget_user_profile(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching profile", error);
      }
    };

    fetchUserProfile();
  }, [_id, token]);

  let editprofile = () => {
    setdisablestatus(true);
  };

  const Profile = (event) => {
    let user_image = event.target.files[0];
    setprofilevalue({ ...profilevalue, user_image });
    setpimage(URL.createObjectURL(event.target.files[0]));
  };

  let profil_input_Hanel = (e) => {
    setprofilevalue({ ...profilevalue, [e.target.name]: e.target.value });
  };

  let profile_form_handel = (e) => {
    e.preventDefault();
    // console.log(profilevalue)
    let formdata = new FormData();
    formdata.append("user_id", profilevalue.user_id);
    formdata.append("full_name", profilevalue.full_name);
    formdata.append("email", profilevalue.email);
    formdata.append("user_image", profilevalue.user_image);

    axios
      .post(
        `${process.env.REACT_APP_API}website/update_user_profile`,
        formdata,
        {
          headers: {
            token: token,
          },
        }
      )
      .then((res) => {
        // console.log(res)
        if (res.data.result) {
          toast.success(res.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  
  return (
    <div>
      <ToastContainer position="top-center" />
      <div
        className="tab-pane fade active show"
        id="account-info"
        role="tabpanel"
      >
        <div className="myaccount-content">
          <input
            id="profilepic"
            onChange={Profile}
            type="file"
            style={{ opacity: "0" }}
          />
          <button
            className="btn btn-dark"
            style={{ float: "right" }}
            onClick={editprofile}
          >
            Edit
          </button>
          <h3>Account Details</h3>
          <div className="account-details-form">
            <div className="row">
              <div className="col-lg-4 col-sm-12 col-md-6 row justify-content-center text-center">
                <div
                  className="shadow text-center "
                  style={{
                    width: "60%",
                    height: "180px",
                    border: "1px solid",
                    borderRadius: "170px",
                  }}
                >
                  {disablestatus == true ? (
                    <img
                      className="channel-profile-img "
                      height={"100%"}
                      width={"100%"}
                      style={{ borderRadius: "50%" }}
                      src={showp_image}
                    />
                  ) : (
                    <img
                      className="channel-profile-img "
                      height={"100%"}
                      width={"100%"}
                      style={{ borderRadius: "50%" }}
                      src={
                        get_user_profile?.user_image
                          ? `${process.env.REACT_APP_API}uploads/${get_user_profile?.user_image}`
                          : "assets/images/logo/logo-dark.png"
                      }
                    />
                  )}
                </div>

                {disablestatus == true ? (
                  <label className="" for="profilepic">
                    <BsFillCloudUploadFill
                      style={{
                        fontSize: "25px ",
                        cursor: "pointer",
                      }}
                    />{" "}
                  </label>
                ) : (
                  ""
                )}
              </div>
              <div className="col-lg-8 col-sm-12 col-md-6">
                {disablestatus == true ? (
                  <form method="post" onSubmit={profile_form_handel}>
                    <div className="form-group">
                      <label htmlFor="name">Full Name:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={profil_input_Hanel}
                        name="full_name"
                        defaultValue={get_user_profile?.full_name}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="pwd">Email:</label>
                      <input
                        type="email"
                        className="form-control"
                        onChange={profil_input_Hanel}
                        name="email"
                        defaultValue={get_user_profile?.email}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="num">Number:</label>
                      <input
                        type="number"
                        className="form-control"
                        disabled
                        defaultValue={get_user_profile?.mobile_no}
                      />
                    </div>
                    <div className="col-12 text-center">
                      <button className="btn btn-dark">Save Changes</button>
                    </div>
                  </form>
                ) : (
                  <form method="post">
                    <div className="form-group">
                      <label htmlFor="name">Full Name:</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        defaultValue={get_user_profile?.full_name}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="pwd">Email:</label>
                      <input
                        type="email"
                        className="form-control"
                        disabled
                        defaultValue={get_user_profile?.email}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="num">Number:</label>
                      <input
                        type="number"
                        className="form-control"
                        disabled
                        defaultValue={get_user_profile?.mobile_no}
                      />
                    </div>
                    <div className="col-12 text-center">
                      <button disabled className="btn btn-dark">
                        Save Changes
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
